import { useEffect } from "react";
import styled from "@emotion/styled";
import { FaArrowRight, FaCheck } from "react-icons/fa6";
import { Link } from "react-router-dom";
import StyledLink from "../Molecules/StyledLink";
import Button from "../Molecules/ButtonLogin";

const ForgotPasswordSuccessBox = (props) => {
  const { config, location, navigate } = props;
  const email = location?.state?.email;

  useEffect(() => {
    if (!email?.length) {
      navigate("/login");
    }
  }, [email, navigate]);

  return (
    <StyledForgotPasswordSuccessBox>
      <span className="title">Redefinir Senha</span>
      <FaCheck size={120} color={"#9CDE59"} />
      <span className="subtitle">
        Se o e-mail for válido, você receberá as instruções para redefinir sua
        senha no endereço:
      </span>
      <span className="email">{email}</span>

      <div className="action-container">
        <Button onClick={() => navigate("/login")}>Fazer login</Button>
        <StyledLink to={"/cadastro"} config={config}>
          Cadastrar novo e-mail
          <FaArrowRight />
        </StyledLink>
      </div>
    </StyledForgotPasswordSuccessBox>
  );
};

export default ForgotPasswordSuccessBox;

const StyledForgotPasswordSuccessBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  margin-top: 42px;
  height: 100%;

  span {
    text-align: center;
  }

  .action-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 24px;
    gap: 24px;
  }

  .title {
    font-family: "Roboto Condensed";
    text-transform: uppercase;
    font-weight: bold;
    font-size: 38px;
    line-height: 49.4px;
    color: #006e3d;
  }

  .subtitle {
    font-family: "Roboto";
    font-weight: 400;
    font-size: 21px;
    line-height: 33.6px;
    color: #8c8c8c;
  }

  .email {
    font-family: "Roboto";
    font-weight: bold;
    font-size: 32px;
    color: #006e3d;
  }
`;
